// extracted by mini-css-extract-plugin
module.exports = {"form-card":"FormCard_form-card__3ogEo"};